"use client";

import { useState, useCallback } from "react";
import { useHeaderScroll } from "@/hooks/useHeaderScroll";
import { Logo } from "./Logo";
import { DesktopMenu } from "./DesktopMenu";
import { CurtainMenu } from "./CurtainMenu";
import { HamburgerButton } from "./HamburgerButton";
import { cn } from "@/lib/utils";

export function Header() {
  const scrolled = useHeaderScroll();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 px-5 py-4 sm:px-8 lg:px-10 sm:py-6">
        <div
          className={cn(
            "mx-auto flex h-16 items-center justify-between rounded-full transition-all duration-500",
            scrolled
              ? "max-w-[700px] border border-white/10 bg-black/20 px-6 shadow-2xl backdrop-blur-2xl"
              : "max-w-full bg-transparent px-0"
          )}
        >
          <Logo />

          <div className="flex items-center gap-6">
            {!scrolled && !menuOpen && (
              <DesktopMenu hidden={false} />
            )}

            <HamburgerButton
              isOpen={menuOpen}
              onClick={handleToggle}
            />
          </div>
        </div>
      </header>

      <CurtainMenu
        isOpen={menuOpen}
        onClose={handleClose}
      />
    </>
  );
}